import { Grid, Typography } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import UniversalToolBarWithDialogs from "../../../bar/UniversalToolBarWithDialogs";
import LoaderWrapper from "../../../wrapper/LoaderWrapper";
import FilterTable from "../../../table/FilterTable";
import useHRService from "../../../../services/hrService";
import { useAsync } from "../../../../hooks/useAsync";
import usePaginationWithSearchParams from "../../../../hooks/usePaginationWithSearchParams";
import useLocalData from "../../../../hooks/useLocalData";
import { useEmptyArrayMemo } from "../../../../hooks/useEmptyArrayMemo";
import TableService from "../../../../services/tableService";
import { answersBySurveyExportUrl, answersBySurveyUrl, hrAnswerRegistryExportUrl } from "../../../../helpers/apiUrls";
import { SURVEY_SUMMARY_TABLE_FIELDS_CONFIG, SURVEY_SUMMARY_TABLE_NAME } from "./TabTablesConfig";
import { useTranslation } from "react-i18next";
import { useForm } from "../../../../hooks/useForm";
import BaseBox from "../../../base/BaseBox/baseBox";
import AutocompleteField from "../../../field/AutocompleteField";
import { subSeconds } from "date-fns";
import SurveySummaryForm from "./SurveySummaryForm";
import { isEmptyValue } from "../../../../helpers/methods";



export default function SurveyResultsTab(props) {
  const { t } = useTranslation();


  const [selectedSurveyId, setSelectedSurveyId] = useState(undefined)

  const { pageName } = props;

  const TABLE_CONFIGS = [
    { name: SURVEY_SUMMARY_TABLE_NAME, config: SURVEY_SUMMARY_TABLE_FIELDS_CONFIG },
  ];

  const {
    formValue,
    onChangeAutocompleteFieldWithObjectOptionsAndCallback,
  } = useForm();

  const {
    getSurveyResultData,
    getSurveysSelectList,
    getAnswersBySurveyList,
  } = useHRService();


  const { emptyArrayMemo } = useEmptyArrayMemo()

  const onChangeSurvey = useCallback(
    (name, value) => {
      setSelectedSurveyId(value);
    },
  );

 const surveysSelectList = useAsync(()=>{
  return getSurveysSelectList({'is_open' : false})
 },[])

  const {
    page: answerPage,
    pageSize: answerPageSize,
    handleChangePageWithSearchParams: handleChangeAnswerPage,
    handleChangePageSizeWithSearchParams: handleChangeAnswerPageSize,
    resetPageNumber: resetAnswerPageNumber,
    searchParams: answerSearchParams,
    setSearchParams,
    onClearSearchParams: onClear
  } = usePaginationWithSearchParams();

  const getSurveySummaryFn = useCallback(() => {
    if (!isEmptyValue(selectedSurveyId)) {
      return getSurveyResultData
    }
    return undefined
  }, [selectedSurveyId])

  const getAnswerListFn = useCallback(() => {
   if (!isEmptyValue(selectedSurveyId)) {
      return getAnswersBySurveyList
    }
    return undefined 
  }, [selectedSurveyId]) 

  const {
    data: surveySummaryData,
    summaryLoading,
  } = useLocalData(getSurveySummaryFn(), undefined, false, selectedSurveyId);

  const {
    data: answerData,
    dataCount,
    dataLoading,
    tableData: answerTableData
  } = useLocalData(getAnswerListFn(), answerSearchParams, true, selectedSurveyId, SURVEY_SUMMARY_TABLE_FIELDS_CONFIG, [], []);

  const answerExportHeaders = useMemo(() => {
    return TableService.getTableExportHeaders(
      SURVEY_SUMMARY_TABLE_FIELDS_CONFIG,
      [],
      []
    );
  }, [
    SURVEY_SUMMARY_TABLE_FIELDS_CONFIG,
  ]);


  return (

    <Grid
      container
      item
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      rowSpacing={1}
    >
      <LoaderWrapper showLoader={surveysSelectList.loading}>
      <Grid item xs={12} marginY={1}>
        <AutocompleteField
          name={`id`}
          label={t(`tabs.survey_results_tab.select_survey`)}
          value={selectedSurveyId}
          options={surveysSelectList.value || []}
          isObjectOption={true}
          optionLabelKey={"hrsurvey_name"}
          addNewValue={false}
          onChange={onChangeAutocompleteFieldWithObjectOptionsAndCallback(onChangeSurvey)}
        />
      </Grid>
      </LoaderWrapper>
      <LoaderWrapper showLoader={props.filteringData.loading || summaryLoading}>
        {selectedSurveyId ? (
          <>
            <Grid item xs={12}>
              <SurveySummaryForm surveySummaryData={surveySummaryData} />
            </Grid>
            <Grid item xs={12}>
              <FilterTable
                data={answerTableData}
                showCheckbox={false}
                showCleanFilterIcon={true}
                countRecords={dataCount}
                page={answerPage}
                onPageChange={handleChangeAnswerPage}
                rowsPerPage={answerPageSize}
                onRowsPerPageChange={handleChangeAnswerPageSize}
                resetPageNumber={resetAnswerPageNumber}
                filteringData={props.filteringData}
                style={{ maxHeight: "vh" }}
                tableConfig={SURVEY_SUMMARY_TABLE_FIELDS_CONFIG}
                showContextMenu={false}
                headersConfig={TableService.getHeadersConfigForCollapsibleTable(
                  SURVEY_SUMMARY_TABLE_FIELDS_CONFIG,
                  props.filteringData || emptyArrayMemo,
                  emptyArrayMemo,
                  emptyArrayMemo,
                )}
                showExportToFileButton={true}
                exportToFileUrl={answersBySurveyExportUrl(selectedSurveyId)}
                exportToFileSearchParams={answerSearchParams}
                exportToFileHeaders={answerExportHeaders}
                exportToFileFileName={`${t(
                  "tabs.survey_results_tab.survey_results"
                ).replace(" ", "_")}.xlsx`}
                isLoading={dataLoading}
              />
            </Grid>
          </>) :
          <Grid item xs={12}>
            <BaseBox>
              <Typography
                textAlign="center"
                variant="overline"
                display="block"
                gutterBottom
                style={{
                  margin: 0,
                  fontSize: "20px",
                  color: "var(--primary)",
                }}
              >
                {t("tabs.survey_results_tab.select_survey_first")}
              </Typography>
            </BaseBox>
          </Grid>
        }
      </LoaderWrapper>
    </Grid>
  
  );
}
